// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__v9hqd","actions":"GroupTable_actions__2_hXU","deleteModalFooter":"GroupTable_deleteModalFooter__3ruUH"};